import React from 'react';
import PropTypes from 'prop-types';

const VerticalTextLockup = ({ title, subtitle }) => (
  <div className="vertical-text-lockup">
    <div className="title">{title}</div>
    <div className="subtitle">{subtitle}</div>
  </div>
);

VerticalTextLockup.propTypes = {
  title: PropTypes.object,
  subtitle: PropTypes.object,
};

export default VerticalTextLockup;



// WEBPACK FOOTER //
// ./library/app/components/Global/Typography/VerticalTextLockup.js